import { CoinsIcon, FileSpreadsheetIcon, FileTextIcon, HandshakeIcon, TablePropertiesIcon, TicketIcon, User2Icon } from "lucide-react";
import { usePermittedReports } from "@/features/reports/hooks/usePermittedReports";
import { SearchableModel } from "../types/searchableModel.type";
import { PermittedReportsTransformer } from "@/features/reports/services/permittedReportsTransformer";
import { useSupportTickets } from "@/features/support/hooks/useSupportTickets";
import { SupportTicketsTransformer } from "@/features/support/services/supportTicketsTransformer";
import { useBillingEvents } from "../hooks/queries/useBillingEvents";
import { useBillingBills } from "../hooks/queries/useBillingBills";
import { BillsTransformer } from "@/features/billingBills/services/billsTransformer";
import { BillingEventTransformer } from "@/features/billingEvents/services/billingEventTransformer";
import { useNegotiations } from "@/features/negotiations/hooks/useNegotiations";
import { NegotiationsTransformer } from "@/features/negotiations/services/NegotiationsTransformer";
import { useBillingEventsWithFiscalDocumentRequirement } from "@/features/billing/hooks/useBillingEventWithFiscalDocumentRequirement";
import { useBillingFiscalDocumentGroups } from "@/features/billing/hooks/useBillingFiscalDocumentGroups";
import { BillingEventsFiscalDocumentsTransformer } from "@/features/billing/services/eventsFiscalDocumentsTransformer";
import { BillingFiscalDocumentGroupsTransformer } from "@/features/billing/services/fiscalDocumentGroupsTransformer";
import { EstablishmentUsersTransformer } from "@/features/users/services/establishmentUsersTransformer";
import { useEstablishmentUsers } from "@/features/users/hooks/useEstablishmentUsers";

export const searchableModels: SearchableModel[] = [
  {
    label: 'Usuários',
    icon: User2Icon,
    hook: useEstablishmentUsers,
    mapper: EstablishmentUsersTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Faturas',
    icon: FileTextIcon,
    hook: useBillingBills,
    mapper: BillsTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Transações',
    icon: FileTextIcon,
    hook: useBillingEvents,
    mapper: BillingEventTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Negociações',
    icon: HandshakeIcon,
    hook: useNegotiations,
    mapper: NegotiationsTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Recolha de notas fiscais por transação',
    icon: CoinsIcon,
    hook: useBillingEventsWithFiscalDocumentRequirement,
    mapper: BillingEventsFiscalDocumentsTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Recolha de notas fiscais por lote',
    icon: TablePropertiesIcon,
    hook: useBillingFiscalDocumentGroups,
    mapper: BillingFiscalDocumentGroupsTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Relatórios',
    icon: FileSpreadsheetIcon,
    hook: usePermittedReports,
    mapper: PermittedReportsTransformer.quickSearchModelTransformer,
  },
  {
    label: 'Chamados',
    icon: TicketIcon,
    hook: useSupportTickets,
    mapper: SupportTicketsTransformer.quickSearchModelTransformer,
  },
];
